/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ periods: NonNullable<unknown>, month: NonNullable<unknown>, customers: NonNullable<unknown> }} Partner_Detail_Periods_MetaInputs */



/**
* | output |
* | --- |
* | "{periods} periods closed in {month}, across {customers} customers" |
*
* @param {Partner_Detail_Periods_MetaInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_detail_periods_meta = /** @type {((inputs: Partner_Detail_Periods_MetaInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Detail_Periods_MetaInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.periods} Zeiträume in ${i?.month} abgeschlossen, über ${i?.customers} Kunden`)
	return /** @type {LocalizedString} */ (`${i?.periods} periods closed in ${i?.month}, across ${i?.customers} customers`)
});